import "./Banner.css";
import { Form, Nav, Tab } from "react-bootstrap";
import { useContext, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import Full_screen_modal from "../../common/full_screen_modal/Full_screen_modal";
import { Success_lottie } from "../../common/lotties/success_lottie/Success_lottie";
import Common_Btn from "../../common/common-btn/Common_Btn";

import { Context } from "../../../utils/context";
import {
  Banners,
  FreeConsultations,
  ConsultationTypes,
  AvgMonthlyBills,
} from "../../../utils/apis/homepage";
import { IDS } from "../../../utils/common";
import { Link } from "react-router-dom";
import Common_heading from "../../common/common_heading/Common_heading";

function Banner() {
  const [activeTab, setActiveTab] = useState(1);
  const [activeBudget, setActiveBudget] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const { IMG_URL } = useContext(Context);

  const [banner, setBanner] = useState([]);
  const [consultationTypes, setConsultationTypes] = useState([]);
  const [monthlyBills, setMonthlyBills] = useState([]);

  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    consultation_type_id: 1,
    avg_monthly_bill_id: null,
    first_name: "",
    last_name: "",
    whatsapp_no: "",
    city: "",
    pincode: "",
    privacy_policy: false,
  });

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  useEffect(() => {
    if (showModal) {
      const timer = setTimeout(() => {
        setShowModal(false);
      },2000); 

      return () => clearTimeout(timer);
    }
  }, [showModal]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "whatsapp_no") {
      if (!/^\d*$/.test(value)) return;
      if (value.length > 10) return;
    }

    if (name === "pincode") {
      if (!/^\d*$/.test(value)) return;
      if (value.length > 6) return;
    }

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });

    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const validate = () => {
    const e = {};

    //if (!formData.name.trim()) e.name = "Name is required";

    if (!formData.first_name.trim()) e.first_name = "First name is required";

    if (!formData.last_name.trim()) e.last_name = "Last name is required";

    if (!formData.city.trim()) e.city = "City is required";

    if (!formData.whatsapp_no) e.whatsapp_no = "WhatsApp number required";
    else if (formData.whatsapp_no.length !== 10)
      e.whatsapp_no = "Enter valid 10 digit number";

    if (!formData.pincode) e.pincode = "Pincode required";
    else if (formData.pincode.length !== 6)
      e.pincode = "Enter valid 6 digit pincode";

    if (!formData.privacy_policy)
      e.privacy_policy = "Please accept privacy policy";

    if (!formData.avg_monthly_bill_id)
      e.avg_monthly_bill_id = "Please select your avg monthly bill";

    return e;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const payload = {
      ...formData,
      name: `${formData.first_name} ${formData.last_name}`, //merge
    };

    delete payload.first_name;
    delete payload.last_name;

    const res = await FreeConsultations(payload);

    if (res?.success) {
      setShowModal(true);

      setFormData({
        consultation_type_id: 1,
        avg_monthly_bill_id: null,
        first_name: "",
        last_name: "",
        whatsapp_no: "",
        city: "",
        pincode: "",
        privacy_policy: false,
      });

      setErrors({});
    }
  };

  const getBanner = async () => {
    const res = await Banners();
    if (res?.success) setBanner(res.data);
  };

  const getConsultationTypes = async () => {
    const res = await ConsultationTypes();
    if (res?.success) setConsultationTypes(res.data);
  };

  const getMonthlyBills = async () => {
    const res = await AvgMonthlyBills();
    if (res?.success) setMonthlyBills(res.data);
  };

  useEffect(() => {
    getBanner();
    getConsultationTypes();
    getMonthlyBills();
  }, []);

  return (
    <>
      <section className="home_banner">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation
          pagination={{ clickable: true }}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          className="bannerSwiper"
        >
          {banner?.map((item, index) => (
            <SwiperSlide key={index}>
              <div
                className="banner_slide"
               
              >
                <div className="banner_img_holder">
                  <img src={IMG_URL + item?.image} alt={item?.name}  className="banner_img"/>
                </div>
               
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      {/* <div className="banner_form_wrapper">
        <div className="banner_right_div">

          <Common_heading title="Schedule a FREE Consultation" subtitle="with Deligencia Today!" />

          <Tab.Container
            activeKey={activeTab}
            onSelect={(val) => {
              setActiveTab(Number(val));

              setFormData((prev) => ({
                ...prev,
                consultation_type_id: Number(val),
              }));
            }}
          >
            <div className="right_div_tab_holder">
              <Nav variant="pills" className="right_div_tabs">
                {consultationTypes?.map((type) => (
                  <Nav.Item key={type?.id}>
                    <Nav.Link eventKey={type?.id}>{type?.name}</Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </div>

            <Tab.Content className="mt-4">
              {consultationTypes?.map((type) => (
                <Tab.Pane eventKey={type?.id} key={type?.id}>
                  <Form className="banner_form" onSubmit={handleSubmit}>
                    <div className="form_grid">
                      <div className="row">
                        <div className="col-12 col-lg-6 mb-3">
                          <Form.Label>
                            First Name<span>*</span>
                          </Form.Label>

                          <Form.Control
                            type="text"
                            name="first_name"
                            value={formData?.first_name}
                            onChange={handleChange}
                            placeholder="Enter First Name*"
                          />

                          {errors.first_name && (
                            <p style={{ color: "red" }}>{errors.first_name}</p>
                          )}
                        </div>

                        <div className="col-12 col-lg-6 mb-3">
                          <Form.Label>
                            Last Name<span>*</span>
                          </Form.Label>

                          <Form.Control
                            type="text"
                            name="last_name"
                            value={formData?.last_name}
                            onChange={handleChange}
                            placeholder="Enter Last Name*"
                          />

                          {errors.last_name && (
                            <p style={{ color: "red" }}>{errors.last_name}</p>
                          )}
                        </div>

                        <div className="col-12 col-lg-6 mb-3">
                          <Form.Label>
                            Enter City<span>*</span>
                          </Form.Label>

                          <Form.Control
                            type="text"
                            name="city"
                            value={formData?.city}
                            onChange={handleChange}
                            placeholder="Enter City*"
                          />

                          {errors.city && (
                            <p style={{ color: "red" }}>{errors.city}</p>
                          )}
                        </div>

                        <div className="col-6">
                          <Form.Label>
                            WhatsApp No<span>*</span>
                          </Form.Label>

                          <Form.Control
                            type="text"
                            name="whatsapp_no"
                            value={formData?.whatsapp_no}
                            onChange={handleChange}
                            placeholder="Enter 10 digit No.*"
                            maxLength={10}
                          />

                          {errors.whatsapp_no && (
                            <p style={{ color: "red" }}>{errors.whatsapp_no}</p>
                          )}
                        </div>

                        <div className="col-6">
                          <Form.Label>
                            Pin code<span>*</span>
                          </Form.Label>

                          <Form.Control
                            type="text"
                            name="pincode"
                            value={formData?.pincode}
                            onChange={handleChange}
                            placeholder="eg. 453722*"
                            maxLength={6}
                          />

                          {errors.pincode && (
                            <p style={{ color: "red" }}>{errors.pincode}</p>
                          )}
                        </div>
                      </div>
                    </div>

                    <Form.Label className="mt-3">
                      What is your average monthly bill?<span>*</span>
                    </Form.Label>

                    <Tab.Container
                      activeKey={activeBudget}
                      onSelect={(val) => {
                        setActiveBudget(Number(val));

                        setFormData((prev) => ({
                          ...prev,
                          avg_monthly_bill_id: Number(val),
                        }));

                        setErrors((prev) => ({
                          ...prev,
                          avg_monthly_bill_id: "",
                        }));
                      }}
                    >
                      <Nav className="row g-2 mb-3 budget_tabs">
                        {[...monthlyBills]
                          .sort((a, b) => {
                            const getValue = (str) => {
                              if (!str) return 0;

                              str = str.toLowerCase();

                              if (str.includes("less")) return 0;

                              if (str.includes("more")) {
                                return parseInt(str.replace(/\D/g, "")) || 0;
                              }

                              const nums = str.match(/\d+/g);
                              return nums ? parseInt(nums[0]) : 0;
                            };

                            return getValue(a.name) - getValue(b.name);
                          })
                          .map((bill) => (
                            <Nav.Item className="col-6 col-md-4" key={bill.id}>
                              <Nav.Link
                                eventKey={bill.id}
                                className="budget_btn"
                              >
                                {bill.name}
                              </Nav.Link>
                            </Nav.Item>
                          ))}
                      </Nav>
                      {errors.avg_monthly_bill_id && (
                        <p style={{ color: "red", marginTop: "20px" }}>
                          {errors.avg_monthly_bill_id}
                        </p>
                      )}
                    </Tab.Container>

                    <div className="d-flex align-items-start gap-2">
                      <Form.Check
                        type="checkbox"
                        name="privacy_policy"
                        checked={formData?.privacy_policy}
                        onChange={handleChange}
                      />
                      <p className="terms_text">
                        I agree to Deligencia's{" "}
                        <span>
                          <Link to="/terms-of-services" target="_blank">
                            TERMS OF SERVICE
                          </Link>{" "}
                          &{" "}
                          <Link to="/privacy-policy" target="_blank">
                            PRIVACY POLICY*
                          </Link>
                        </span>
                      </p>
                    </div>

                    {errors.privacy_policy && (
                      <p style={{ color: "red" }}>{errors.privacy_policy}</p>
                    )}

                    <div className="button_holder">
                      <Common_Btn text={"Submit"} />
                    </div>
                  </Form>
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Tab.Container>
        </div>
      </div> */}

      <Full_screen_modal
        show={showModal}
        // onHide={() => setShowModal(false)}
        lottie={<Success_lottie />}
      />
    </>
  );
}

export default Banner;
